import { createSelector } from 'reselect';

import Cookies from '@comeon/tomcat-cookies';

import { SessionStorageKeys } from '~/components/brand/constants';
import { isAppSupportsSwish } from '~/components/payment/deposit-beta/utils/swish-app-redirect-util.js';

import NS from './reducer-name';

// FIXME and remove after migration
/// const TEMPLATE_OVERRIDE = process.env.TEMPLATE || '';

export const selectCurrencies = state => state[NS].currencies;
export const selectLicense = state => state[NS].license;
export const selectIsDesktop = state => state[NS].isDesktop;
export const selectGermanProductSwitchEnabled = state => state[NS].isGermanProductSwitchEnabled;
export const selectOntarioFranchise = state => state[NS].isOntarioRegulatedFranchise;
export const selectNetherlandsFranchise = state => state[NS].isNetherlandsRegulatedFranchise;
export const selectIsGermanRegulatedFranchise = state => state[NS].isGermanRegulatedFranchise;

export const selectSiteCode = state => state[NS].siteCode;
export const selectBrandName = state => state[NS].brandName;
export const selectDefaultProduct = state => state[NS].defaultProduct;
export const selectOneBankIDFlowEnabled = state => state[NS].oneBankIDFlowEnabled;
export const selectBlackFridayCampaignEnabled = state => state[NS].blackFridayCampaignEnabled;
export const selectShowLocaleSelector = state => state[NS].showLocaleSelector;
export const selectSiteType = state => state[NS].siteType;
export const selectProposedLocale = state => state[NS].proposedLocale;
export const selectDisableProposedLocaleForFranchise = state => state[NS].disableProposedLocaleForFranchise;
export const selectBrand = state => state[NS];
export const selectDefaultLocale = state => state[NS].defaultLocale;
export const selectCurrentUrlLang = state => state[NS].currentUrlLang;
export const selectHtmlLang = state => state[NS].htmlLang;
export const selectShowMentorMessages = state => state[NS].showMentorMessages;
export const selectSiteId = state => state[NS].siteId;
export const selectHasPromotions = state => state[NS].HasPromotions;
export const selectEnableShopVersionTwo = state => state[NS].enableShopVersionTwo;
export const selectEnableShopVersionThree = state => state[NS].enableShopVersionThree;
export const selectEnableShopSaleCountdown = state => state[NS].enableShopSaleCountdown;
export const selectEnablePromotionsVersionThree = state => state[NS].enablePromotionsVersionThree;
export const selectEnableMarketplaceBonusDisclaimer = state => state[NS].enableMarketplaceBonusDisclaimer;
export const selectShowShopClosedHeader = state => state[NS].showShopClosedHeader;
export const selectFranchiseId = state => state[NS].franchiseId;
export const selectFranchiseCode = state => state[NS].franchiseCode;
export const selectEnableAddOnScript = state => state[NS].enableAddOnScript;
export const selectFranchiseName = state => state[NS].franchiseName;
export const selectPolishFranchise = state => state[NS].isPolishFranchise;
export const selectIsGuestPlayer = state => state[NS].isGuestPlayer;
export const selectGuestLocale = state => state[NS].guestLocale;
export const selectIsDefaultFranchiseLanguageSelected = state => {
	return state[NS].locales && state[NS].locales.some(locale => locale.defaultFranchiseLocale && locale.checked);
};
export const selectProductNavbarShopExternalNewBadgeEnabled = state =>
	state[NS].productNavbarShopExternalNewBadgeEnabled;
export const selectIsShopEnabled = state => state[NS].isShopEnabled;
export const selectEnableMarketplaceSplit = state => state[NS].enableMarketplaceSplit;
export const selectSportsbookMaximumBetslipItems = state => state[NS].sportsbookMaximumBetslipItems;
export const selectSportsbookMaximumBetslipSystemItems = state => state[NS].sportsbookMaximumBetslipSystemItems;
export const selectSportsbookOddsFormatToggleEnabled = state => state[NS].sportsbookOddsFormatToggleEnabled;
export const selectShowNewCookieBanner = state => state[NS].showNewCookieBanner;
export const selectTvBetScriptUrl = state => state[NS].tvBetScriptUrl;
export const selectTvBetMobileGameCode = state => state[NS].tvBetMobileGameCode;
export const selectTvBetDesktopGameCode = state => state[NS].tvBetDesktopGameCode;
// export const selectTemplate = state => TEMPLATE_OVERRIDE || state[NS].template;
export const selectShowTrustLogos = state => state[NS].showTrustLogos;
export const selectEnableMultiStepRegistration = state => state[NS].enableMultiStepRegistration;
export const selectSGADepositLimitsEnabled = state => state[NS].depositLimitsSwedishRegulationEnabled;
export const selectOasisBanMaintenanceEnabled = state => state[NS].oasisBanMaintenanceEnabled;
export const selectMojeIDEnabled = state => {
	return state[NS].mojeIDEnabled && sessionStorage.getItem('showTransactionLink') !== 'true';
};
export const selectTransactionLinkEnabled = state => {
	return state[NS].transactionLinkEnabled || sessionStorage.getItem('showTransactionLink') === 'true';
};
export const selectEnableMergedRGReasonsPage = state => state[NS].enableMergedRGReasonsPage;
export const selectEnableAccountClosureFeedback = state => state[NS].enableAccountClosureFeedback;
export const selectEnableFeedbackRecommendations = state => state[NS].enableAccountClosureFeedbackRecommendations;

export const selectForceNormalRegistration = state => state[NS].forceNormalRegistration;
export const selectProducts = state => state[NS].products;
export const selectMainContentLoading = state => state[NS].mainContentLoading;
export const selectExpandTermsAndDescriptions = state => state[NS].expandTermsAndDescriptions;

export const selectPendingResultTracking = state => state[NS].pendingResultTracking;
export const selectNewResultFlow = state =>
	state[NS].enableNewResultFlow && !sessionStorage.getItem('disableNewResultFlow');

export const selectSwishQRCodeFlowDesktop = state =>
	state[NS].enableSwishQRcodeFlowDesktop &&
	state[NS].isDesktop &&
	!sessionStorage.getItem('disableSwishQRcodeFlowDesktop');

export const selectSwishRedirectFlowMobile = state =>
	state[NS].enableSwishRedirectFlowMobile &&
	!state[NS].isDesktop &&
	!sessionStorage.getItem('disableSwishRedirectFlowMobile') &&
	isAppSupportsSwish();

export const selectSwishQRCodeFlow = state =>
	selectSwishQRCodeFlowDesktop(state) || selectSwishRedirectFlowMobile(state);

export const selectQuickDepositMobile = state => state[NS].enableMobileQuickDeposit;

export const selectMobileIngameToolbar = state => state[NS].enableMobileIngameToolbar;

export const selectNavbarMenu = state => state[NS].menu.navbar;
export const selectLandingpageMenu = state => state[NS].menu.landingPage;

export const selectVirtualsInspiredEnabled = state => state[NS].virtualsInspiredEnabled;
export const selectVirtualsHighlightGamesEnabled = state => state[NS].virtualsHighlightGamesEnabled;

export const selectHasProducts = createSelector(selectProducts, products => ({
	hasSportsbook: products.includes('sportsbook'),
	hasLivebetting: products.includes('live-betting'),
	hasVirtuals: products.includes('virtuals'),
	hasCasino: products.includes('casino'),
	hasLivecasino: products.includes('livecasino'),
	hasWeSpin: products.includes('we-spin'),
	hasTvBet: products.includes('tvbet')
}));

export const selectCasinoMaintenanceEnabled = state => state[NS].casinoMaintenanceEnabled;

export const selectCasinoHeartbeatUrl = state => state[NS].casinoHeartbeatUrl;
export const selectCasinoEndHeartbeatUrl = state => state[NS].casinoEndHeartbeatUrl;
export const selectCasinoHeartbeatInterval = state => state[NS].casinoHeartbeatInterval;

export const selectCasinoFiltersEnabled = () => false;
export const selectLiveCasinoFiltersEnabled = state =>
	state[NS].enableLiveCasinoFilters || sessionStorage.getItem(SessionStorageKeys.ENABLE_LC3_FEATURE) === 'true';

const selectCasinoFilterAmountCurrencies = state => state[NS].casinoFilterAmountCurrencies;
export const selectActiveCurrency = (_, currency) => currency;

export const selectCasinoFilterAmounts = createSelector(
	[selectCasinoFilterAmountCurrencies, state => state, selectActiveCurrency],
	(currencies, state, activeCurrency) => {
		// we retrieve the currencies as a comma seperated string thus splitting into an array
		const amountCurrenciesArray = currencies?.split(',');
		const isActiveCurrencyListedInAmounts = amountCurrenciesArray?.some(currency => currency === activeCurrency);

		if (isActiveCurrencyListedInAmounts) {
			const amountRanges = state[NS][`casinoFilterAmountRanges_${activeCurrency}`].split(',');
			const highestRange = amountRanges?.at(-1);
			const highestAmount = highestRange?.match(/\d+$/i);

			if (amountRanges?.length) {
				return amountRanges.concat(highestAmount);
			}
		}

		return null;
	}
);

export const selectEnableNewInput = state => state[NS].enableNewInput;

export const selectSportsbookWidgetsEnabled = state => state[NS].sportsbookWidgetsEnabled;
export const selectSportsbookExploreRecommendedCasinoGamesEnabled = state =>
	state[NS].sportsbookExploreRecommendedCasinoGamesEnabled;
export const selectSportsbookFreeBetsEnabled = state => state[NS].sportsbookFreeBetsEnabled;

export const selectSportsbookStatisticsEnabled = state => state[NS].sportsbookStatisticsEnabled;

export const selectSportsbookShareBetslipEnabled = state => state[NS].sportsbookShareBetslipEnabled;
export const selectSportsbookShareBetModalEnabled = state => state[NS].sportsbookShareBetModalEnabled;

export const selectSportsbookSystemBetsEnabled = state => state[NS].sportsbookSystemBetsEnabled;

export const selectSportsbookShowTopLegalTextInMyBets = state => state[NS].sportsbookShowTopLegalTextInMyBets;
export const selectSportsbookOptixSearchEnabled = state => state[NS].sportsbookOptixSearchEnabled;
export const selectSportsbookGlobalOpenBetsEnabled = state => state[NS].sportsbookGlobalOpenBetsEnabled;
export const selectSportsbookBetBuilderSportcastEnabled = state => state[NS].sportsbookBetBuilderEnabled;
export const selectSportsbookBetBuilderBetradarEnabled = state => state[NS].sportsbookBetBuilderBetradarEnabled;
export const selectSportsbookPreCannedCarouselEnabled = state => state[NS].sportsbookPreCannedCarouselEnabled;
export const selectSportsbookPreCannedCarouselPositionBottomPageEnabled = state =>
	state[NS].sportsbookPreCannedCarouselPositionBottomPageEnabled;
export const selectSportsbookBetRecommendationsEnabled = state => state[NS].sportsbookBetRecommendationsEnabled;
export const selectSportsbookBetRecommendationsOnExplorePageEnabled = state =>
	state[NS].sportsbookBetRecommendationsOnExplorePageEnabled;
export const selectSportsbookBetRecommendationsInBetslipEnabled = state =>
	state[NS].sportsbookBetRecommendationsInBetslipEnabled;
export const selectSportsbookQuickDepositEnabled = state => state[NS].sportsbookQuickDepositEnabled;
export const selectSportsbookDefaultOddsFormat = state => state[NS].sportsbookDefaultOddsFormat;
export const selectSportsbookRegistrationButtonEnabled = state => state[NS].sportsbookRegistrationButtonEnabled;
export const selectSportsbookValidateProductBalanceEnabled = state => state[NS].sportsbookValidateProductBalanceEnabled;
export const selectSportsbookBetBuilderLocaleFallbackEnabled = state =>
	state[NS].sportsbookBetBuilderLocaleFallbackEnabled;
export const selectSportsbookLuckyBetEnabled = state => state[NS].sportsbookLuckyBetEnabled;
export const selectSportsbookBetGeniusStreamingEnabled = state => state[NS].sportsbookBetGeniusStreamingEnabled;
export const selectSportsbookBetGeniusGameTrackerEnabled = state => state[NS].sportsbookBetGeniusGameTrackerEnabled;
export const selectSportsbookBetslipPreferredReplacementEnabled = state =>
	state[NS].sportsbookBetslipPreferredReplacementEnabled;
export const selectSportsbookBetBuilderTimeout = state => state[NS].sportsbookBetBuilderTimeout; // Seconds
export const selectSportsbookWebSocketConnectionErrorNotificationEnabled = state =>
	state[NS].sportsbookWebsocketConnectionErrorNotificationEnabled;
export const selectSportsbookEuroQuickLinkEnabled = state => state[NS].sportsbookEuroQuickLinkEnabled;

export const selectSportsbookCrossSellEnabled = state => state[NS].sportsbookCrossSellEnabled;
export const selectSportsbookPoolXEnabled = state => state[NS].sportsbookPoolXEnabled;
export const selectSportsbookUnifiedFeedEnabled = state => state[NS].sportsbookUnifiedFeedEnabled;

export const selectEnableTCChangePlace = state => state[NS].enableTCChangePlace;
export const selectShowBannerTermsAndCondition = state => state[NS].showBannerTermsAndCondition;
export const selectBannerTermsAndConditionText = state => state[NS].bannerTermsAndConditionText;

export const selectEnableBannerService = state => state[NS].enableBannerService;

export const selectEnableInhouseJackpot = state => state[NS].enableInhouseJackpot;
export const selectInhouseJackpotIconUrl = state => state[NS].inhouseJackpotOptinIconUrl;
export const selectEnableInhouseJackpotViewV2 = state => state[NS].enableInhouseJackpotViewV2;
export const selectEnableBeyondPlayJackpot = state => state[NS].enableBeyondPlayJackpot;
export const selectEnableSplashJackpot = state => state[NS].enableSplashJackpot;

export const selectEnableTournamentService = state => state[NS].enableTournamentService;

export const selectEnableLiveCasino3 = state =>
	state[NS].enableLiveCasino3 || sessionStorage.getItem(SessionStorageKeys.ENABLE_LC3_FEATURE) === 'true';
export const selectGameInfoSlotsDataEnabled = state => state[NS].gameInfoSlotsDataEnabled;

export const selectShowDropsWinsPragmatic = state => state[NS].showDropsWinsPragmatic;

export const selectCasinoSubMenuItems = state => state[NS].casinoSubmenuItems;

export const selectEnablePayPalGermany = state => state[NS].enablePayPalGermany;

export const selectIsSeonServiceEnabled = state => state[NS].isSeonServiceEnabled;

export const selectIsSeonEnabled = state => state[NS].isSeonDeviceIdEnabled;

export const selectEnableLocationSmart = state => state[NS].enableLocationSmart;

export const selectThunderbiteEnabled = state => state[NS].isThunderbiteEnabled;

export const selectThunderbiteMultipleCampaignsEnabled = state => state[NS].isThunderbiteMultipleCampaignEnabled;

export const selectNewOneButtonFlow = state => state[NS].enableNewOneButtonFlow;

export const selectOneButtonFlow = state => state[NS].oneButtonFlowEnabled;

export const selectHidePaymentDepositFees = state => state[NS].hidePaymentDepositFees;

export const selectHidePaymentWithdrawFees = state => state[NS].hidePaymentWithdrawFees;

export const selectEnableDepositRecommendedGames = state => state[NS].enableDepositRecommendedGames;

export const selectEnableDepositRecommendedBets = state => state[NS].enableDepositRecommendedBets;

export const selectEnableNewCasinoQDDesigns = state => state[NS].enableNewCasinoQDDesigns;

export const selectShowWDAddressDetailsPopup = state => state[NS].showWDAddressDetailsPopup;

export const selectEnableNewCardNameCheckFlow = state => state[NS].enableNewCardNameCheckFlow;

export const selectIsSplashtechEnabled = state => state[NS].isSplashtechEnabled;

export const selectThunderbiteOnLogin = state => state[NS].thunderbiteOnLogin;

export const selectEnableOnfido = state => state[NS].enableOnfido;

export const selectSplashtechOnLogin = state => state[NS].splashtechOnLogin;

export const selectSplashtechLoggedOut = state => state[NS].splashtechLoggedOut;

export const selectEnableNorwayExpressRegistration = state => state[NS].enableNorwayExpressRegistration;

export const selectEnableNorwayExpressLogin = state => state[NS].enableNorwayExpressLogin;

export const selectDisableUsernamePasswordLogin = state => state[NS].disableUsernamePasswordLogin;

export const selectShowRegistrationProgressStepper = state => state[NS].showRegistrationProgressStepper;

export const selectTempAccountFlow = state => state[NS].enableTempAccountFlow;

export const selectEnableB2BRegistration = state => state[NS].xSellFastRegistration;

export const selectIsWalletEnabled = state => state[NS].isWalletEnabled;

export const selectIsBotRequest = state => state[NS].isBotRequest;

export const selectIsRegistrationBlocked = state => state[NS].isRegistrationBlocked;

export const selectSportsbookAcceptModesEnabled = state => state[NS].sportsbookAcceptModesEnabled;

export const selectSiteHostname = state => state[NS].siteHostname;

export const selectJapanFranchise = state => state[NS].isJapanFranchise;
export const selectGlobalFranchise = state => state[NS].isGlobalFranchise;

export const selectWebPushEnabled = state => state[NS].webPushEnabled;
export const selectWebPushTriggerSuccessDeposit = state => state[NS].webPushTriggerSuccessDeposit;
export const selectWebPushTriggerWithdrawRequest = state => state[NS].webPushTriggerWithdrawRequest;
export const selectWebPushTriggerWeSpinSuccess = state => state[NS].webPushTriggerWeSpinSuccess;

export const selectMyNotificationsEnabled = state => state[NS].myNotificationsEnabled;
export const selectSystemMessageEnabled = state => state[NS].systemMessageEnabled;
export const selectSystemMessage = state => state[NS].systemMessage;

export const selectEnablePreCanned = state => state[NS].sportsbookPreCannedEnabled;

export const isDanishFranchise = state => state[NS].isDanishFranchise;

export const IsGermanRegulatedFranchise = state => state[NS].isGermanRegulatedFranchise;

export const selectIsNetherlandsRegulatedFranchise = state => state[NS].isNetherlandsRegulatedFranchise;

export const selectSwedishRegulatedFranchise = state => state[NS].isSwedishRegulatedFranchise;

export const selectShowDetailedBalance = state => state[NS].enableDetailedBalance;

export const selectAuthResGamingLimit = state => state[NS].hasAuthResGamingLimit;

export const selectRCWebSocket = state => state[NS].enableRCWebSocket;

export const selectIsCddnMockEnabled = state => state[NS].isCddnMockEnabled;

export const selectSupport = state => state.support;

export const selectUseCustomLogos = state => state[NS].useCustomLogos;
export const selectIsRealityCheckEnabled = state => state[NS].isRealityCheckEnabled;

export const selectIsNewPWEnabled = state => state[NS].isNewPWEnabled && !sessionStorage.getItem('disableNewPW');

export const selectEnableBonusCode = state => state[NS].enableBonusCode;

export const selectPreloadTournamentsCategory = state => state[NS].preloadTournamentsCategory;
export const selectGraphyteSearchEnabled = state => state[NS].graphyteSearchEnabled;

export const selectIsNewCashierEnabled = state => state[NS].enableNewCashier;
export const selectIsNewDepositFlow = state =>
	state[NS].isNewDepositFlow && !sessionStorage.getItem('disableNewDepositFlow');
export const selectIsNewCashierQDFlow = state =>
	state[NS].isNewDepositQDFlow && !sessionStorage.getItem('disableNewDepositQDFlow');

export const selectSuggestedAmounts = state => state[NS].suggestedAmounts;
export const selectLimitNotificationDismissTime = state => state[NS].limitNotificationDismissTime;
export const selectTrustlyLoginPollTime = state => state[NS].trustlyLoginPollTime;
export const selectVerifyEmail = state => state[NS].verifyEmail;
export const selectDoEmailVerification = state => state[NS].doEmailVerification;
export const selectDepositLimitsGermanRegulationEnabled = state => state[NS].depositLimitsGermanRegulationEnabled;
export const selectVerifyCheckTermsEnabled = state => state[NS].verifyCheckTermsEnabled;
export const selectShowLoginAsGuestOption = state => state[NS].showLoginAsGuestOption;

/**
 * Limits suggestions for DGA registration
 */

const mockSuggestion = Cookies.get('mockdk_suggestions');
export const selectDepositLimitsSuggestions = state =>
	sessionStorage.getItem(SessionStorageKeys.DEPOSIT_LIMITS_SUGGESTIONS_KEY) === `true` || !!mockSuggestion
		? state[NS].depositLimitsSuggestions
		: '';

export const selectEnableBonusPackage = state => state[NS].enableBonusPackage;

export const selectLocales = state => state[NS].locales;
export const selectIsoCodeForLocale = createSelector(
	selectLocales,
	locales => locales.find(item => item.checked).isoCode
);
export const selectLangNameForLocale = createSelector(
	selectLocales,
	locales => locales.find(item => item.checked).langName
);
export const selectLocale = createSelector(selectLocales, locales => locales.find(item => item.checked).locale);
export const selectLocaleObject = createSelector(selectLocales, locales => locales.find(item => item.checked));

export const selectDefaultDepositLoginAmount = state => state[NS].defaultDepositLoginAmount;
export const selectBankIdDepositDetails = state => state[NS].bankIdDepositDetails;
export const selectLanguageProductSEOMap = state => state[NS].languageProductSEOMap;

export const selectGlobalNavigationEnabled = state => state[NS].globalNavigationEnabled;

export const selectNavigation = state => state[NS].navigation;

export const selectLastProduct = state => state[NS].lastProduct;

export const selectKreditzFirstEnabled = state => state[NS].enableKreditzFirst;
export const selectEnableCSAButtonInMobileVerify = state => state[NS].enableCSAButtonInMobileVerify;
